import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Typography, CircularProgress } from "@mui/material";

import { UploadingMedia } from "../../../api/types/feed.types";

interface UploadingMediaPreviewProps {
  item: UploadingMedia;
  onRemove: () => void;
}

const styles = {
  container: {
    width: "fit-content",
    position: "relative",
    borderRadius: "8px",
  },
  image: {
    width: "160px",
    height: "160px",
    objectFit: "cover",
  },
  video: {
    width: "160px",
    height: "160px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  removeButton: {
    position: "absolute",
    top: 4,
    right: 4,
    padding: "4px",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.9)",
    },
  },
  progressOverlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  progressText: {
    position: "absolute",
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "10.5px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "15px",
  },
};

export const UploadingMediaPreview = ({ item, onRemove }: UploadingMediaPreviewProps) => {
  return (
    <Box sx={styles.container}>
      {item.type === "IMAGE" ? (
        <Box component="img" src={URL.createObjectURL(item.file)} alt="" sx={styles.image} />
      ) : (
        <Box sx={styles.video} />
      )}
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        sx={styles.removeButton}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      <Box sx={styles.progressOverlay}>
        <CircularProgress
          variant="determinate"
          value={item.progress}
          size={45}
          sx={{
            "& .MuiCircularProgress-circle": {
              strokeWidth: 5,
            },
          }}
        />
        <Typography sx={styles.progressText}>{Math.round(item.progress)}%</Typography>
      </Box>
    </Box>
  );
};
